import { Layout } from '@wix/design-system'
import React, { FC, memo } from 'react'

import type { Content } from '../Content'
import { MembersOption } from './MembersOption'

type Option = Content['members']['options'][number]

type MembersSelectProps = {
  options: Option[]
  value: string
  onSelect?: (option: Option) => void
}

export const MembersSelect: FC<MembersSelectProps> = memo(({ options, value, onSelect }) => (
  <Layout gap="6px" rowHeight="1fr">
    {options.map(option => (
      <MembersOption key={option.optionKey} option={option} checked={option.optionKey === value} onClick={onSelect} />
    ))}
  </Layout>
))
